export const API_URL_SEND_EMAIL_WITH_QR = "/shop/api/esim/sendemail";
